export class AuthenticationTransKey {
  static readonly login = "authentication.login";
  static readonly forgotPw = "authentication.forgotPw";
}
